export default function () {
  if (this.$store.state.app.session.token) {
    this.$router.push({
      name: 'Dashboard',
    })
  }
}
